import { Navigate } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import SessionReload from "./component-assets/SessionReload";
import {compareRole, iAmHigherAuthority} from "../libs";
import TasksEhr from "./TasksEhr";
import TestComponent from "./TestComponent";
import TasksMaint from "./TasksMaint";

const Tasks = (props) => {
    let tasksContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (paramVars.dType === "ehr" && (compareRole("caregiver", dData?.userrole) || iAmHigherAuthority(10, dData.role_weight))){
        tasksContent = <TasksEhr />;
        // tasksContent = <TestComponent />
    }else if (paramVars.dType === "maintenance"){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            tasksContent = <TasksMaint />
        }else{
            return <Navigate to={"/"} />
        }
    }else{
        tasksContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (dData.campusData[dData.acnt.toString()]?.ehr_active || iAmHigherAuthority(10, dData.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {tasksContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Tasks;